import { makeSelectors } from '@utils/css';

const wrapper = "_ecwcn8z66";
const image = "_eci9x09mu";
const postloadedImageSelectors = makeSelectors({
  image,
  wrapper
});

export { image, postloadedImageSelectors, wrapper };
import "./postloaded-image.style.linaria.module.css";
//# sourceMappingURL=postloaded-image.style.js.map
